import { render, staticRenderFns } from "./resync-finddoc-badge-modal.vue?vue&type=template&id=405f70ae&scoped=true&"
import script from "./resync-finddoc-badge-modal.vue?vue&type=script&lang=ts&"
export * from "./resync-finddoc-badge-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405f70ae",
  null
  
)

export default component.exports